<template>
  <div class="address-custom">
    <e-suggestion
      :suggestionEndpoint="suggestionEndpoint"
      :transformSuggestions="transformSuggestions"
      :name="name"
      :model="model"
      :required="required"
      :disabled="disabled"
      @selectItem="selectItem"
      :minSuggestLen="1"
      :suggestDelay="100"
      :placeholder="placeholder"
      ref="input"
    ></e-suggestion>
  </div>
</template>

<script>
  import {AddressModel} from "./AddressModel"
  import {core} from "../../api/api-endpoints"

  // data-* attributes used for debug
  export default {
    name: 'address-custom',
    data () {
      return {
        error: null
      }
    },
    props: {
      onChangeValidation: {
        type: Boolean,
        default: false
      },
      formValidator: null,
      model: {
        type: Object,
        required: true
      },
      tabView: {
        type: String,
        default: null
      },
      name: {
        type: String,
        default: null,
        required: true
      },
      validateAlias: {
        type: String,
        default: null
      },
      required: {
        type: Boolean,
        default: false
      },
      modalVariableName: {
        type: String,
        default: null
      },
      disabled: {
        type: Boolean,
        default: false
      },
      placeholder: {
        type: String,
        default: null
      },
      inputType: {
        type: String,
        default: 'text'
      },
      mask: {
        type: String,
        default: null
      },
      onValidate: {
        type: Function,
        default: (obj) => obj
      },
      addressData: {
        type: Object,
        required: true,
        default: function () {
          return {}
        }
      },
      addressIdFieldName: {
        type: String,
        default: 'address_id'
      },
      houseFiasFieldName: {
        type: String,
        default: null
      },
      fiasFieldName: {
        type: String,
        default: null
      },
      geoFields: {
        type: Array
      },
      callbacks: {
        type: Object,
        default: () => ({
          onSuggestionsFetch: () => void null,
          onSuggestMount: () => void null
        })
      }
    },
    computed: {
      getPlaceholder () {
        if (this.placeholder === null) {
          return ''
        }
        return this.placeholder
      },
      hasError () {
        if (this.error) {
          return true
        }
        return false
      }
    },
    created () {
      if (this.formValidator) {
        this.formValidator.subscribeInput(this)
      }
    },
    destroyed () {
      if (this.formValidator) {
        this.formValidator.unsubscribeInput(this)
      }
    },
    methods: {
      getElement () {
        return this.$refs.input.getElement()
      },
      selectItem (raw) {
        const data = new AddressModel()
        data.value = raw.name
        data.raw = raw
        data.data.setCustom(raw)
        data.addressIdFieldName = this.addressIdFieldName
        data.houseFiasFieldName = this.houseFiasFieldName
        data.fiasFieldName = this.fiasFieldName
        this.addressData[this.name] = data
        this.model[this.name] = data.value

        if (this.houseFiasFieldName) {
          this.model[this.houseFiasFieldName] = data.data.house_fias_id
        }

        if (this.fiasFieldName) {
          this.model[this.fiasFieldName] = data.data.fias_id
        }

        if (this.geoFields) {
          this.model[this.geoFields[0]] = data.data.geo_lat
          this.model[this.geoFields[1]] = data.data.geo_lon
        }

        this.$emit('selectItem', data)
      },
      suggestionEndpoint (ctx, q) {
        return core.houseSearch(q)
      },
      transformSuggestions (ctx, data) {
        console.log('transformSuggestions', data)
        return data.data
      },
      validate () {
        let msg = ''
        if (this.required && !this.model[this.name]) {
          msg += 'Укажите адрес'
        }

        if (this.required && this.fiasFieldName && !this.model[this.fiasFieldName]) {
          msg = 'Начните вводить и выберите адрес из списка'
        }

        if (this.required && this.houseFiasFieldName && !this.model[this.houseFiasFieldName]) {
          msg = 'Укажите адрес, включающий номер дома'
        }

        return this.onValidate({
          error: msg,
          tabView: this.tabView,
          name: this.name,
          modalVariableName: this.modalVariableName,
          el: this.getElement(),
          model: this.model
        })
      }
    }
  }
</script>
